export default __webpack_public_path__ + "static/media/fida.1e26814f.png";